import { supabase } from "@/lib/supabase/client"

export async function apiFetch(url: string, options: RequestInit = {}) {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  const headers = new Headers(options.headers || {})

  // 🔐 auth
  if (session?.access_token) {
    headers.set("Authorization", `Bearer ${session.access_token}`)
  }

  // ⚠️ SOLO setear JSON si NO es FormData
  if (!(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json")
  }

  return fetch(url, {
    ...options,
    headers,
    credentials: "include",
  })
}